module.exports = __webpack_public_path__ + "static/media/red-warning.fc430af0.svg";